import { getApiUrl } from './api';

const API_URL = getApiUrl();

export const KDS_DEVICE_STORAGE_KEY = 'brutos-kds-device-session';

export const getKdsDeviceSession = () => {
  if (typeof window === 'undefined') return null;

  try {
    const raw = window.localStorage.getItem(KDS_DEVICE_STORAGE_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    return parsed?.token ? parsed : null;
  } catch {
    return null;
  }
};

const storeKdsDeviceSession = (session) => {
  if (typeof window === 'undefined') return;
  window.localStorage.setItem(KDS_DEVICE_STORAGE_KEY, JSON.stringify(session));
};

export const clearKdsDeviceSession = () => {
  if (typeof window === 'undefined') return;
  window.localStorage.removeItem(KDS_DEVICE_STORAGE_KEY);
};

const toHeaders = (headers) => (
  headers instanceof Headers ? new Headers(headers) : new Headers(headers || {})
);

export const kdsDeviceFetch = async (path, options = {}) => {
  const session = getKdsDeviceSession();
  const headers = toHeaders(options.headers);

  if (session?.token && !headers.has('X-KDS-Token')) {
    headers.set('X-KDS-Token', session.token);
  }

  const url = /^https?:\/\//i.test(path) ? path : `${API_URL}${path}`;
  const response = await fetch(url, { ...options, headers });

  if (response.status === 401) {
    clearKdsDeviceSession();
  }

  return response;
};

export const connectKdsDevice = async (pin) => {
  const response = await fetch(`${API_URL}/api/kds/device/connect`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ pin }),
  });
  const data = await response.json().catch(() => ({}));

  if (!response.ok || data.success === false || !data.token) {
    throw new Error('KDS_PIN_INVALID');
  }

  const session = {
    token: data.token,
    expiresAt: data.expiresAt || '',
    company: data.company || null,
  };
  storeKdsDeviceSession(session);
  return session;
};

export const fetchKdsDeviceSession = async () => {
  const response = await kdsDeviceFetch('/api/kds/device/session');
  const data = await response.json().catch(() => ({}));

  if (!response.ok || data.success === false) {
    throw new Error('KDS_SESSION_INVALID');
  }

  const current = getKdsDeviceSession();
  if (current?.token) {
    storeKdsDeviceSession({
      ...current,
      expiresAt: data.expiresAt || current.expiresAt || '',
      company: data.company || current.company || null,
    });
  }

  return data;
};
